/* TODO: t() */
import React, { PureComponent } from 'react';
import { View, StyleSheet } from 'react-native';

import FormField from '../helpers/FormField';
import { Checkbox, RadioGroup, RadioItem } from '../../../uiold';

import { FormFieldDefinition } from '../../../../types/shared/FormFieldDefinition';

type Props = {
  definition: FormFieldDefinition;
  readOnly?: boolean;
  onChange?: (id: string, value: boolean) => void;
};

type State = {
  value: boolean;
};

class BooleanElementFormView extends PureComponent<Props, State> {
  state: State = {
    value: getDefaultValue(this.props),
  };

  render() {
    let { props } = this;
    let { definition } = props;
    // TODO: Better solution here.
    if (definition.type !== 'BooleanElement') {
      return null;
    }
    let hideLabel = definition.use_checkbox;
    return (
      <FormField {...props} hideLabel={hideLabel}>
        <View style={styles.fieldDiv}>{this._renderField()}</View>
      </FormField>
    );
  }

  componentDidUpdate(prevProps: Props) {
    if (getDefaultValue(prevProps) !== getDefaultValue(this.props)) {
      this.setState({ value: getDefaultValue(this.props) });
    }
  }

  _renderField = () => {
    let { value } = this.state;
    let { definition, readOnly } = this.props;
    // TODO: Better solution here.
    if (definition.type !== 'BooleanElement') {
      return null;
    }
    let tabIndex = readOnly ? -1 : undefined;
    if (definition.use_checkbox) {
      return (
        <Checkbox
          isChecked={value}
          tabIndex={tabIndex}
          onChange={this._onChange}
          text={definition.label}
          style={styles.noPadding}
          testID={`form-${definition.id}-yes`}
        />
      );
    }
    return (
      <RadioGroup
        alignHorizontal
        selectedValue={value}
        onChange={this._onChange}
      >
        <RadioItem
          key={1}
          testID={`form-${definition.id}-yes`}
          value={true}
          tabIndex={tabIndex}
          title="Yes"
          style={styles.noPadding}
        />
        <RadioItem
          key={2}
          testID={`form-${definition.id}-no`}
          value={false}
          tabIndex={tabIndex}
          title="No"
          style={styles.noPadding}
        />
      </RadioGroup>
    );
  };

  _onChange = () => {
    this.setState({ value: !this.state.value });
    let { onChange, definition } = this.props;
    if (onChange != null) {
      onChange(definition.id, !this.state.value);
    }
  };

  setValue = (value: unknown) => {
    this.setState({ value: Boolean(value) });
  };

  getValue = () => {
    return this.state.value;
  };
}

let styles = StyleSheet.create({
  fieldDiv: {
    flexDirection: 'row',
    paddingVertical: 5,
  },
  noPadding: {
    paddingVertical: 0,
  },
});

function getDefaultValue(props: Props) {
  // TODO: Better solution here.
  let { definition } = props;
  let defaultValue =
    definition.type === 'BooleanElement' ? definition.default_value : null;
  return defaultValue || false;
}
export default BooleanElementFormView;
